<template>
  <div class="userWrap">
    <h4>修改登录密码</h4>

    <div class="formWrap">
      <el-form :model="resetForm" :rules="rules" ref="resetForm" label-width="0" class="resetForm">
        <el-form-item prop="password">
          <p>新密码</p>
          <el-input type="password" v-model="resetForm.password" size="medium" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="checkPassword">
          <p>确认新密码</p>
          <el-input type="password" v-model="resetForm.checkPassword" size="medium" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="pay_password">
          <p>支付密码</p>
          <el-input type="password" v-model="resetForm.pay_password" size="medium" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="code">
          <p>验证码 <span class="signTel">接收手机 {{signTel}}</span></p>
          <el-input v-model="resetForm.code" size="medium" autocomplete="off">
            <template slot="append">
              <span @click="getOPT">{{optWords}}</span>
            </template>
          </el-input>
        </el-form-item> -->

        <div class="submit">
          <el-button type="primary" size="medium" @click="regForm('resetForm')">
            {{pc_lang.Confirm_submission}}
          </el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import * as API_USER from '@/api/user'
import * as RegExp from '@/utils/RegExp'

export default {
  name: 'UserResetPassword',
  components: {

  },
  data() {
    return {
      resetForm: {
        password: '',
        checkPassword: '',
        pay_password: '',
        code: ''
      },
      optTimer: null,
      optBool: 1,
      optWords2: ''
    }
  },
  computed: {
    ...mapGetters(['user']),
    /* 手机加密 */
    signTel() {
      let tel = this.user.mobile
      return !!!tel ? '' : tel.replace(/^(\d{3})\d*(\d{3})$/,'$1****$2')
    },
    rules() {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_the_password));
        } else if( value.length < 6 || value.length > 20 ) {
          callback(new Error(this.pc_lang['4_to_20_characters_in_length']));
        } else {
          if (this.resetForm.checkPassword !== '') {
            this.$refs.resetForm.validateField('checkPassword');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_password_again));
        } else if (value !== this.resetForm.password) {
          callback(new Error(this.pc_lang.The_passwords_entered_twice_are_inconsistent));
        } else {
          callback();
        }
      };
      let validatePay = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_the_password));
        } else if( !RegExp.payword.test(value) ) {
          callback(new Error(this.pc_lang.Password_consists_of_6_digits));
        }else {
          callback();
        }
      };
      return {
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        pay_password: [
          { validator: validatePay, trigger: 'blur' }
        ],
        /*code: [
          { required: true, message: this.pc_lang.Enter_verification_code, trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6个字符', trigger: 'blur' }
        ]*/
      }
    },
    // 验证码单词
    optWords: {
      get() {
        return this.optWords2 == "" ? this.pc_lang.Get_verification_code : this.optWords2
      },
      set(val) {
        this.optWords2 = val
      }
    }
  },
  async mounted() {

  },
  beforeDestroy() {
    try{
      window.clearInterval(this.optTimer)
    }catch(err){}
    this.optTimer = null
  },
  created() {

  },
  methods: {
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // this.regOPT()
          this.submit()
        }
      })
    },
    /* 获取验证码 */
    getOPT() {
      if (this.optBool) {
        this.optBool = 0
        API_USER.pwdSMS().then(res=>{
          let num = res.data || 120
          let optTimer = setInterval(()=> {
            num--
            let word = this.pc_lang.Get_the_code_after_3s.replace(/3/, num)
            if (num <= 0) {
              clearInterval(optTimer)
              this.optWords = this.pc_lang.Get_verification_code
              this.optBool = 1
              return false
            }else{
              this.optWords = word
            }
          }, 1000)
        },rej=> {
          this.optBool = 1
          this.$message.error(rej.msg)
        })
      }
    },
    /* 验证验证码 */
    regOPT() {
      // 场景(修改密码:MODIFY_LOGIN_PASSWORD,修改支付密码:MODIFY_PAY_PASSWORD)
      const params = {
        code: this.resetForm.code,
        scene: 'MODIFY_LOGIN_PASSWORD'
      }
      API_USER.verifycode(params).then(res=> {
        this.submit()
      },
      rej=> {
        this.$message.error(rej.msg)
      })
    },
    /* submit */
    submit() {
      let { password, pay_password } = this.resetForm
      password = md5(password)
      pay_password = md5(pay_password)
      let params = {
        password,
        pay_password
      }
      API_USER.editpwds(params).then(res=> {
        this.$message.success(this.pc_lang.Successful_operate)
        this.$router.push({ name: 'UserSafety' })
      },
      rej=> {
        this.$message.error(rej.msg)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>